<mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="sidenav-tree">
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <li
      [id]="node.code"
      [attr.data-id]="node.code"
      class="mat-tree-node mat-tree-node-nested"
      [ngClass]="{ 'tree-sub-nav': node.level > 1 }">
      <app-tree-sidenav-menu-item [menuNode]="node"></app-tree-sidenav-menu-item>
    </li>
  </mat-tree-node>

  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasNestedChild">
    @if (hasPermission(node)) {
      <li>
        <div class="mat-tree-node" [ngClass]="{ 'root-mat-tree-node': isRootLevel(node) }">
          @if (isRootLevel(node)) {
            <span>{{ node.label }}</span>
          }
          @if (!isRootLevel(node)) {
            <button
              mat-button
              matTreeNodeToggle
              class="sidenav-nested"
              [attr.data-id]="'sidnavOption_' + node.label"
              [attr.aria-label]="'toggle ' + node.label">
              <span class="sidenav-nested-button-label">
                <span>{{ node.label }}</span>
                <mat-icon style="font-size: 20px" class="mat-icon-rtl-mirror">{{
                  nestedTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
                }}</mat-icon>
              </span>
            </button>
          }
        </div>
        <ul [class.sidenav-tree-invisible]="!nestedTreeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    }
  </mat-nested-tree-node>
</mat-tree>
